import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const SuccessPage = () => {
  return (
    <>
      <section
        className="py-5 poisiton-relative text-center d-flex align-items-center justify-center"
        style={{ height: "100vh" }}
      >
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="flex items-center justify-center">{checkIcn}</div>
            </Col>
            <Col lg="12" className="my-2">
              <p className="m-0 text-white">Energy Added Successfully</p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SuccessPage;

const checkIcn = (
  <svg
    width="187"
    height="168"
    viewBox="0 0 187 168"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.3"
      cx="93.5152"
      cy="93.5152"
      r="93.5152"
      fill="url(#paint0_linear_0_7112)"
    />
    <circle
      opacity="0.6"
      cx="93.5"
      cy="93.5"
      r="74.5"
      fill="url(#paint1_linear_0_7112)"
    />
    <circle cx="93" cy="93.5" r="55" fill="url(#paint2_linear_0_7112)" />
    <path
      d="M117.667 76L84.8958 109L70 94"
      stroke="white"
      strokeWidth="7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_0_7112"
        x1="93.5152"
        y1="0"
        x2="93.5152"
        y2="187.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#019EB1" stopOpacity="0.62" />
        <stop offset="0.735" stopColor="#019EB1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_0_7112"
        x1="93.5"
        y1="19"
        x2="93.5"
        y2="168"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#019EB1" stopOpacity="0.62" />
        <stop offset="0.875" stopColor="#019EB1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_0_7112"
        x1="93"
        y1="38.5"
        x2="93"
        y2="148.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#019EB1" stopOpacity="0.62" />
        <stop offset="1" stopColor="#019EB1" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
